import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Alert, Anchor } from '@zillow/constellation';
import {
  getAreCriminalReportsTemporarilyUnavailableSelector,
  getAreCriminalReportsUnavailableSelector,
  getAreEvictionReportsTemporarilyUnavailableSelector,
  getAreEvictionReportsUnavailableSelector,
  getIsBackgroundReportUnavailableDueToMissingSsnSelector,
  getIsBackgroundReportUnavailableSelector,
  getWasRetrieveSharedReportsGatewayTimeoutSelector,
} from '../../../../../../../selectors/sharedReports';
import { URLS } from '../../../../../../../constants/urls';
import CustomerSupportLink from '../../../../../../../components/CustomerSupport/CustomerSupportLink';
import GatewayTimeoutAlertBody from '../../../../../../../components/CustomerSupport/GatewayTimeoutAlertBody';

function BackgroundCheckGeneralAlert({ applicant }) {
  const { userId: applicantId } = applicant;
  const areCriminalReportsTemporarilyUnavailable = useSelector(
    getAreCriminalReportsTemporarilyUnavailableSelector(applicantId),
  );
  const areEvictionReportsTemporarilyUnavailable = useSelector(
    getAreEvictionReportsTemporarilyUnavailableSelector(applicantId),
  );
  const areCriminalReportsUnavailable = useSelector(getAreCriminalReportsUnavailableSelector(applicantId));
  const areEvictionReportsUnavailable = useSelector(getAreEvictionReportsUnavailableSelector(applicantId));
  const isBackgroundReportUnavailable = useSelector(getIsBackgroundReportUnavailableSelector(applicantId));
  const isBackgroundReportUnavailableDueToMissingSsn = useSelector(
    getIsBackgroundReportUnavailableDueToMissingSsnSelector(applicantId),
  );
  const didRetrievalFailOnGatewayTimeout = useSelector(getWasRetrieveSharedReportsGatewayTimeoutSelector(applicantId));

  let body = null;

  if (isBackgroundReportUnavailableDueToMissingSsn) {
    body = (
      <>
        Background report can't be pulled because the renter did not apply with their Social Security Number. Please
        direct the renter to our{' '}
        <Anchor target="_blank" href={URLS.UNAVAILABLE_BACKGROUND_REPORT_FAQ}>
          FAQs
        </Anchor>
        .
      </>
    );
  } else if (didRetrievalFailOnGatewayTimeout) {
    body = GatewayTimeoutAlertBody;
    // The report or both sections are unavailable, and neither is in dispute.
  } else if (
    isBackgroundReportUnavailable &&
    !areCriminalReportsTemporarilyUnavailable &&
    !areEvictionReportsTemporarilyUnavailable
  ) {
    body = (
      <>Background report can’t be pulled due to an error. Please contact {CustomerSupportLink} to report the issue.</>
    );
  } else if (
    (areCriminalReportsUnavailable && !areCriminalReportsTemporarilyUnavailable) ||
    (areEvictionReportsUnavailable && !areEvictionReportsTemporarilyUnavailable)
  ) {
    body = (
      <>
        Some of the report information can’t be pulled due to an error. Please contact {CustomerSupportLink} to report
        the issue.
      </>
    );
  }

  return body && <Alert appearance="warning" body={body} />;
}

BackgroundCheckGeneralAlert.propTypes = {
  applicant: PropTypes.shape({
    userId: PropTypes.string.isRequired,
  }).isRequired,
};

export default BackgroundCheckGeneralAlert;
